<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vvKEWD/tc-custom/9781497663022.jpg?1704717799443" alt="This image is the cover for the book Child's History of England"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Child's History of England
      </h1>
      <p class="bookDescription body article font2">
        <b>Charles Dickens’s charming history of his homeland, spanning from antiquity through the 17th century</b><br/><br/> In this accessible history volume, Charles Dickens turns his talents to the saga of the United Kingdom. With characteristic wit and perspicacity, he brings the kings, soldiers, and civilians who shaped England, Scotland, and Ireland to vivid life. Beginning in 50 B.C.E. and extending through the reign of James II in 1688, this immensely readable book offers readers a complete and engaging look at England’s past.<br/>  <br/> Originally appearing in serial form, <i>A Child’s History of England </i>provides rare snapshots of Britain throughout the ages as rendered by an unparalleled master.<br/>  <br/> This ebook has been professionally proofread to ensure accuracy and readability on all devices.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Dickens
      </h2>
      
      <p class="authorDescription body article">An international celebrity during his lifetime, Charles Dickens (1812&shy;&ndash;1870) is widely regarded as the greatest novelist of the Victorian era. His classic works include&#160;<I>A Christmas Carol</I>,&#160;<I>Oliver Twist</I>,&#160;<I>David Copperfield</I>,&#160;<I>Great Expectations</I>, and&#160;<I>A Tale of Two Cities</I>, one of the bestselling novels of all time. When Dickens was twelve years old, his father was sent to debtors&rsquo; prison, and the boy was forced to work in a boot-blacking factory to support his family. The experience greatly shaped both his fiction and his tireless advocacy for children&rsquo;s rights and social reform.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?614972e6